import type Validator from '../../models/Validator';

const PropertyAddressValidator: Validator = class {
  static isValid(value) {
    if (value) {
      return value.length > 5;
    }

    return false;
  }

  static getError() {
    return 'Enter a valid address';
  }
};

export default PropertyAddressValidator;
